/**
 * Redistributes remaining budget across unlocked episodes when one episode amount changes,
 * keeping the total fixed (same logic as backend equal split with cent remainder).
 * Locked episodes keep their current amounts.
 */
export const redistributeFixedTotal = (
  details,
  changedDetailId,
  newAmount,
  targetTotal,
  lockedDetailIds = []
) => {
  const lockedSet = new Set(lockedDetailIds);
  const parsedNew = parseFloat(newAmount);
  if (isNaN(parsedNew) || parsedNew < 0) {
    return details;
  }

  const otherDetails = details.filter(
    (d) => d.id !== changedDetailId && !lockedSet.has(d.id)
  );
  const lockedTotal = details
    .filter((d) => d.id !== changedDetailId && lockedSet.has(d.id))
    .reduce((sum, d) => sum + (parseFloat(d.exp_d_amount) || 0), 0);
  const remaining = Math.round((targetTotal - parsedNew - lockedTotal) * 100) / 100;

  if (otherDetails.length === 0) {
    return details.map((d) =>
      d.id === changedDetailId ? { ...d, exp_d_amount: parsedNew } : d
    );
  }

  if (remaining < 0) {
    return details.map((d) =>
      d.id === changedDetailId ? { ...d, exp_d_amount: parsedNew } : d
    );
  }

  const episodeVal = Math.floor((remaining / otherDetails.length) * 100) / 100;
  const remainderCents = Math.round((remaining - episodeVal * otherDetails.length) * 100);

  const amountById = {};
  otherDetails.forEach((detail, index) => {
    let amount = episodeVal;
    if (index < remainderCents) {
      amount = Math.round((episodeVal + 0.01) * 100) / 100;
    }
    amountById[detail.id] = amount;
  });

  return details.map((d) => {
    if (d.id === changedDetailId) {
      return { ...d, exp_d_amount: parsedNew };
    }
    if (amountById[d.id] !== undefined) {
      return { ...d, exp_d_amount: amountById[d.id] };
    }
    return d;
  });
};

export const getDetailsTotal = (details) =>
  (details || []).reduce(
    (total, detail) => total + (parseFloat(detail.exp_d_amount) || 0),
    0
  );

export const PREDICTION_TOTAL_MODES = {
  FIXED: 'fixed',
  VARIABLE: 'variable',
};
